import {Identification} from "./Identification";

export default interface IDesconnectedByServerMessage
{
    OtherMachine?: Identification;
    Message?: string;
    Code?: DesconnectCodes;    
}



export enum DesconnectCodes
{
    SIMULTANEOUS_ACCESS_NOT_ALLOWED
}